import { Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { BaseDirective } from '../../base.directive';

@Component({
    selector: 'eui-footer',
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['./_styles/_index.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class EuiFooterComponent extends BaseDirective {

    @HostBinding('class')
    get cssClasses() {
        const rootClass = 'eui-footer';
        return [
            super.getCssClasses(rootClass),
        ].join(' ').trim();
    }

    constructor() {
        super();
    }
}
